// src/utils/roleHelper.js
export const getRoleFromRoleId = (roleId) => {
  const roleMap = {
    1: "Administrateur",
    2: "Utilisateur",
    3: "Dirigeant Club",
    4: "Arbitrage",
    5: "Responsable Arbitrage",
    6: "Membre de la Ligue NA",
    7: "Responsables Comités Départementaux",
    8: "Enseignant-Coach",
  };
  return roleMap[Number(roleId)] || "user";
};

/**
 * Retourne true si l'utilisateur est autorisé.
 * - Accepte allowedRoles comme tableau de numbers, strings, ou objets { id }.
 * - Si allowedRoles est vide / absent => PUBLIC => true.
 */
export const checkRoleAccess = (userRoleId, allowedRoles) => {
  if (!Array.isArray(allowedRoles) || allowedRoles.length === 0) return true;

  const canonical = (x) => {
    if (x == null) return null;
    if (typeof x === "object" && "id" in x) x = x.id;
    const n = Number(x);
    return Number.isFinite(n) ? `#${n}` : String(x).toLowerCase().trim();
  };

  const userKey = canonical(userRoleId);
  if (!userKey) return false;

  const allowedSet = new Set(
    allowedRoles.map(canonical).filter(Boolean)
  );

  return allowedSet.has(userKey);
};
